import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { IPlaylistSortInfo, IVideoPlaylist } from './VideoPlaylist.Contract';

import { VideoPlaybackService } from './VideoPlayback.Service';

@Component({
	selector: 'video-playlist-container',
	templateUrl: './VideoPlaylistContainer.Component.html'
})
export class VideoPlaylistContainerComponent implements OnInit, OnDestroy {
	@Input() private video: any;
	@Output() public onCancelPlaylist: EventEmitter<any> = new EventEmitter();

	public isCreatingPlaylist: boolean;
	public isPlaylistSaving: boolean = false;
	public playlistCollection: IVideoPlaylist[];
	public showCreatePlaylist: boolean = false;
	public sortInfo: IPlaylistSortInfo = { field: 'name', sortAscending: true };

	constructor(
		private VideoPlaybackSvc: VideoPlaybackService
	) { }

	public ngOnInit(): void {
		this.VideoPlaybackSvc.subscribePlaylistHandlers();
		this.VideoPlaybackSvc.loadPlaylists()
			.catch(e => console.error('Error loading playlists', e));

		this.VideoPlaybackSvc.playlistCollection$.subscribe((playlists: IVideoPlaylist[]) => {
			this.playlistCollection = playlists.map(playlist => ({ ...playlist }));
		});
	}

	public ngOnDestroy(): void {
		this.VideoPlaybackSvc.unsubscribePlaylistHandlers();
	}

	public savePlaylists({ playlists }: { playlists: IVideoPlaylist[]; }): void {
		this.isPlaylistSaving = true;

		this.VideoPlaybackSvc.savePlaylists(playlists, this.video.id)
			.catch(e => console.error('Save Playlist Error: ', e))
			.finally(() => this.isPlaylistSaving = false);
	}

	public createPlaylist({ playlist }: { playlist: IVideoPlaylist; }): void {
		this.isCreatingPlaylist = true;

		this.VideoPlaybackSvc.createPlaylist(playlist)
			.catch(e => console.error('Create Playlist Error: ', e))
			.finally(() => {
				this.isCreatingPlaylist = false;
				this.showCreatePlaylist = false;
			});
	}

	public sortChange(): void {
		this.sortInfo = {
			field: this.sortInfo.field,
			sortAscending: !this.sortInfo.sortAscending
		};
	}

	public onSelectAllChange(selectAll: boolean): void {
		this.playlistCollection = (this.playlistCollection || []).map(playlist => {
			playlist.isSelected = selectAll;
			return playlist;
		});
	}

	public updatePlaylist({ playlist }: { playlist: IVideoPlaylist; }): void {
		this.VideoPlaybackSvc.updatePlaylist(playlist);
	}
}
